







import q from '@/graphql/query'
import n from '@/utils/notifications'

export default {
    data: ()->
        type_name_set: ['state_choice', 'graduate_level_choice', 'employee_status_choice']

    watch:
        "$store.state.authenticated": (value)->
            # console.log "APP STORE AUTHENTICATE ", value
            if value
                # console.log "APP STORE AUTHENTICATE TRUE", value
                for name in @type_name_set
                    @get_type_choices(name)

        "$store.state.new_content": (new_value, old_value)->
            # console.log "APP NEW CONTENT"
            if new_value != old_value
                @refresh_alert()

    methods:
        refresh_alert: ()->
            # console.log "APP REFRESH ALERT"
            self = @
            @$confirm("De nouveaux contenus sont disponibles, veuillez rafraîchir la page.", 'Information', {
                confirmButtonText: 'Rafraîchir'
                })
                .then ()->
                    self.$router.go()
                .catch (cancel)->
                    return
            return

        get_type_choices: (type_name)->
            self = @
            @errors = {}
            q.run('get_type_set', [type_name])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("app: get_type_choices: then", e.message)
                else
                    # console.log "APP TYPE CHOICES : ", resp.body.data[type_name+'_set']
                    self.$store.commit('set_type', {'type_name':type_name, 'datas':resp.body.data[type_name+'_set']})
            .catch (resp)->
                n.catch_error(resp, "app: get_type_choices()")

    # mounted: ()->
        # console.log "APP MOUNTED"
        # window.addEventListener('unhandledrejection', (event)->
        #     console.log "PROMISE", event.promise
        #     console.log "REASON", event.reason
        # )
}
